<template>
  <b-modal
    ref="modal"
    :cancel-variant="data.cancelVariant || undefined"
    :header-bg-variant="data.headerBgVariant || undefined"
    :footer-bg-variant="data.footerBgVariant || undefined"
    :header-text-variant="data.headerTextVariant || undefined"
    :size="data.size || 'md'"
    :centered="data.centered || undefined"
    :scrollable="data.scrollable || undefined"
    :no-close-on-backdrop="data.noCloseOnBackdrop || undefined"
    :no-close-on-esc="data.noCloseOnEsc || undefined"
    :hide-header-close="data.hideHeaderClose || undefined"

    :title-html="data.title"
    :ok-title="data.okTitle || _trans('Yes')"
    :cancel-title="data.cancelTitle || _trans('No')"
    @hide="hide"
    @hidden="onClose"
    @shown="onShow"
    @ok="close(1)"
    @cancel="close(0)"
    style="height: 80vh;
    width: 60vw;"
  >
    <template v-slot:modal-header-close>
      <b-button
        size="sm"
        variant="primary"
        class="ni ni-close"
        @click="close()"
      >
      </b-button>
    </template>
    
    <!-- <iframe :src="data.src" style="
      width: 100%;
      height: 100%;">
    </iframe> -->

    <embed :src="data.src" style="width: 100%; max-height:60vh" />
    <!-- <object style="width: 100%;" height="800" type="application/pdf" :data="'https://www.tadelia.it/menu.pdf?#' + 'scrollbar=0&toolbar=0&navpanes=0'"></object> -->
    <template v-slot:modal-footer>
      <b-button
        size="sm"
        variant="primary"
        @click="close(1)"
      >
      OK
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import modal from "@dialogs/modal.vue";
export default {
    mixins: [modal]
}
</script>



// WEBPACK FOOTER //
// src/app/dialogs/modalPDF.vue